import React from 'react';
import {
    USBInputBase,
    validationErrors,
    filterErrors,
} from '@usb-shield/react-forms-base';

function RelationshipName({
    statusUpdateCallback,
    selectedValue,
    fieldError,
}) {
    const length = 100;
    const errorMessage = {
        121: `The name must be fewer than 100 characters.`,
        default: `A relationship name is required.`,
    };

    const filteringFunction = (value) => {
        if (value.length > length) {
            return [
                value.slice(0, length),
                filterErrors['maximum-length-exceeded'],
            ];
        }
        return [value, undefined];
    };

    const validationFunction = (value) => {
        // at this point, the filtering has already occured so we are really just checking for length and edge cases.
        if (value.length > length) {
            return validationErrors['maximum-length-exceeded'];
        }
        if (value.length === 0) {
            return validationErrors['no-empty-inputs'];
        }
        return 0;
    };
    return (
        <USBInputBase
            inputName="business-name"
            labelText="Relationship name"
            filteringFunction={filteringFunction}
            dynamicValue={selectedValue}
            validationFunction={validationFunction}
            statusUpdateCallback={(e) => statusUpdateCallback(e)}
            callbackFrequency="every"
            dynamicErrorCount={fieldError}
            showFilterErrors
            showErrorMessage="dynamic"
            errorMessages={errorMessage}
        />
    );
}

export default RelationshipName;
